<script setup lang="ts">
  /**
   * Dialog 关闭按钮组件
   * @description
   * 1. 用于触发弹窗关闭的元素
   * 2. 默认为按钮，可通过 as-child 属性自定义渲染
   */
  import type { DialogCloseProps } from 'reka-ui'
  import { DialogClose } from 'reka-ui'

  const props = defineProps<DialogCloseProps>()
</script>

<template>
  <DialogClose v-bind="props">
    <slot />
  </DialogClose>
</template>
